import MenuSection from "../MenuSection";
import PropTypes from "prop-types";
import React, { useMemo } from "react";
import { MenuItemFactory } from "../MenuItemFactory";
import { usePCCategories } from "./hooks/usePCCategories";

const CategoriesPC = ({ trackingInfo }) => {
  const menuItemsList = usePCCategories(trackingInfo);

  const components = useMemo(
    () =>
      menuItemsList?.map(menuItem => (
        <MenuItemFactory
          key={menuItem.key}
          componentProps={menuItem.props}
          componentType={menuItem.componentType}
        />
      )),
    [menuItemsList]
  );

  return <MenuSection className="categoriesSection">{components}</MenuSection>;
};

CategoriesPC.propTypes = {
  trackingInfo: PropTypes.object
};

export default React.memo(CategoriesPC);
